import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import useLadyService from '@/services/LadyService';
import {
	getStories,
	setStoriesId,
	setStories,
} from '@/stores/slices/modelsState';
import {} from '@/stores/slices/filterSlice';
import { setStoriesStatus } from '@/stores/slices/popupSlice';
import { getUserCurrentCity } from '@/stores/slices/userSlice';
import { makeRequest } from '@/services/makeRequest';
import StoriesCircle from '../../stories/circle/StoriesCircle';

import './storiesSlider.scss';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';
import { useParams } from 'react-router-dom';

const StoriesSlider = ({ size = 'xs' }) => {
	const { dispatch, lang, setMediaSize, t } = useLadyService();
	const FILTER = useFilterLogicContext();
	const [isRenderElem, setIsRenderElem] = useState(true);

	const params = useParams();

	const timeoutId = useRef(null);

	const city = useSelector(getUserCurrentCity);
	const [page, setPage] = useState(1);

	const stories = useSelector(getStories);

	const fetchData = async () => {
		const city_param =
			params?.city && params?.city !== 'czechia'
				? params?.city?.split('_')[0]
				: null;

		try {
			const route = `stories/${city_param || city.id}`;
			const method = 'GET';
			const payload = {
				page,
			};
			const data = await makeRequest({ route, method, payload });
			if (data) {
				const result = data.stories;
				dispatch(setStories(result));
			} else {
				throw new Error('No Stories');
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (!FILTER.isFilterEmpty) {
			setIsRenderElem(false);
		} else {
			setIsRenderElem(true);
		}
	}, [FILTER.filterStateIndicator]);

	useEffect(() => {
		if (lang && page && city.id && stories.length === 0) {
			timeoutId.current = setTimeout(async () => {
				await fetchData();
			}, 500);
		}

		return () => {
			if (timeoutId.current) {
				console.warn(`=> abort stories load. reason: new data`);
				clearTimeout(timeoutId.current);
			}
		};
	}, [lang, page, city.id, params]);

	if (isRenderElem && !!stories.length) {
		return (
			<Swiper
				className={'stories-circle'}
				breakpoints={{
					0: {
						spaceBetween: 30,
						slidesPerView: 'auto',
					},
					1399.98: {
						slidesPerView: 7,
						spaceBetween: 0,
					},
				}}
			>
				{!!stories?.length &&
					stories.map((i, index) => {
						return (
							<SwiperSlide
								onClick={() => {
									dispatch(setStoriesStatus(true));
									dispatch(setStoriesId(index));
								}}
								key={i.id}
								className={`stories-circle__item`}
							>
								<StoriesCircle
									img={setMediaSize(
										i.profile_photo,
										`${size}`,
									)}
									name={i.name}
									age={i.age}
									alt={i.name + ` - ${t('modelstories')}`}
								/>
							</SwiperSlide>
						);
					})}
			</Swiper>
		);
	}
};

export default StoriesSlider;
